export const initialiseMaxHeight = () => {
  // Used to set max height
  const setHeight = () => {
    // We execute the same script as before
    let vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty("--vh", `${vh}px`);
  };
  window.addEventListener("resize", setHeight);
  window.addEventListener("orientationchange", setHeight);
  setHeight();
};
